import React from 'react';
import autobind from 'autobind';
import { inject, observer } from 'mobx-react';
import { makeObservable } from 'mobx';

import { ActionButtonProps } from './ActionButton';
import { Bottom, BottomProps } from './Bottom';
import { EntryPage as EntryPageStore, entryPageService, PageMode } from '@patient/ui/shared/store';
import { RightContent } from '@patient/ui/shared/RightContent';
import { Entry } from '@patient/store/entry/Entry';

interface Props extends BottomProps, ActionButtonProps {}

interface StoreProps {
    entryPage: EntryPageStore;
    entry: Entry;
}

const injectableStores: (keyof StoreProps)[] = [EntryPageStore.Name, Entry.Name];

@observer
export class Component extends React.Component<Props & StoreProps> {
    constructor(props: Props & StoreProps) {
        super(props);
        makeObservable(this);
    }

    public render(): React.ReactNode {
        const { onEntryTypeSelect, ...actionButtonProps } = this.props;

        return React.createElement(Bottom, {
            actionButtonProps,
            onEntryTypeSelect,
            onOpenHistoryClick: this.handleHistoryClick,
        });
    }

    @autobind
    private handleHistoryClick(): void {
        this.setPageMode(PageMode.History);
    }

    private setPageMode(pageMode: PageMode): void {
        const { entryPage, entry } = this.props;

        if (entryPage.pageMode === PageMode.History) {
            this.resetRightContent();
        } else {
            entryPage.pageMode = pageMode;
            this.setRightContent();
        }

        entry.isViewMode = entryPage.pageMode !== PageMode.Edit;
    }

    private setRightContent(): void {
        const children = React.createElement(RightContent);

        this.props.entryPage.onClickOutsideRightContent = this.resetRightContent;
        entryPageService.setRightContent({
            children,
            isShowing: true,
        });
    }

    @autobind
    private resetRightContent(): void {
        const { entryPage, entry } = this.props;
        entryPageService.resetRightContent();
        entry.isViewMode = !(entryPage.pageMode === PageMode.Edit || entryPage.pageMode === PageMode.Template);
    }
}

export const BottomContainer = inject<Props, StoreProps>(...injectableStores)(Component);
